import { render, staticRenderFns } from "./index.vue?vue&type=template&id=964ffff2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/styles/public1.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=964ffff2&prod&scoped=true&lang=less"
import style2 from "./index.vue?vue&type=style&index=2&id=964ffff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964ffff2",
  null
  
)

export default component.exports